package org.example.project.ui

import androidx.compose.foundation.BorderStroke
import androidx.compose.foundation.Image
import androidx.compose.foundation.layout.*
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.foundation.verticalScroll
import androidx.compose.material3.*
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.layout.ContentScale
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.input.PasswordVisualTransformation
import androidx.compose.ui.text.input.VisualTransformation
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import org.example.project.viewmodel.AuthViewModel
import org.jetbrains.compose.resources.painterResource
import battleships.shared.generated.resources.Res
import battleships.shared.generated.resources.ocean
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.filled.Visibility
import androidx.compose.material.icons.filled.VisibilityOff

@Composable
fun AuthScreen(
    authViewModel: AuthViewModel
) {
    BoxWithConstraints(
        modifier = Modifier.fillMaxSize()
    ) {

        val isMobile =
            maxWidth < 700.dp

        Image(
            painter = painterResource(
                Res.drawable.ocean
            ),
            contentDescription = null,
            modifier = Modifier.fillMaxSize(),
            contentScale = ContentScale.Crop
        )

        Column(
            modifier = Modifier
                .fillMaxSize()
                .padding(24.dp),
            horizontalAlignment = Alignment.CenterHorizontally,
            verticalArrangement = Arrangement.Center
        ) {

            Text(
                text = "BATTLESHIPS",
                fontSize =
                    if (isMobile)
                        36.sp
                    else
                        52.sp,
                fontWeight = FontWeight.Bold,
                color = Color.White
            )

            Spacer(
                modifier = Modifier.height(8.dp)
            )

            Text(
                text = "CODE • ATTACK • CONQUER",
                color = Color(0xFF00E5FF),
                fontSize = 18.sp
            )

            Spacer(
                modifier = Modifier.height(
                    if (isMobile)
                        24.dp
                    else
                        40.dp
                )
            )

            Card(
                modifier =
                    if (isMobile) {
                        Modifier.fillMaxWidth()
                    } else {
                        Modifier.width(420.dp)
                    },
                colors = CardDefaults.cardColors(
                    containerColor =
                        Color(0xAA001B33)
                ),
                border = BorderStroke(
                    2.dp,
                    Color(0xFF00E5FF)
                ),
                shape = RoundedCornerShape(20.dp)
            ) {

                Column(
                    modifier = Modifier
                        .fillMaxWidth()
                        .wrapContentHeight()
                        .padding(
                            if (isMobile)
                                16.dp
                            else
                                24.dp
                        ),
                    horizontalAlignment = Alignment.CenterHorizontally
                ) {
                    Text(
                        text = "Sign in with GitHub",
                        color = Color.White,
                        fontSize = 20.sp,
                        fontWeight = FontWeight.Bold
                    )

                    Spacer(
                        modifier = Modifier.height(24.dp)
                    )

                    Button(
                        onClick = {
                            authViewModel.loginWithGitHub()
                        },
                        modifier = Modifier
                            .fillMaxWidth()
                            .height(56.dp),
                        shape = RoundedCornerShape(30.dp),
                        colors = ButtonDefaults.buttonColors(
                            containerColor = Color(0xFF24292E)
                        )
                    ) {
                        Text(
                            text = "Sign in with GitHub",
                            color = Color.White,
                            fontWeight = FontWeight.Bold
                        )
                    }

                    Spacer(
                        modifier = Modifier.height(12.dp)
                    )

                    if (authViewModel.isLoading) {
                        CircularProgressIndicator(
                            color = Color(0xFF00E5FF)
                        )
                    }

                    authViewModel.errorMessage?.let {
                        Spacer(
                            modifier = Modifier.height(12.dp)
                        )

                        Text(
                            text = it,
                            color = Color.Red,
                            fontWeight = FontWeight.Bold
                        )
                    }
                }
            }
        }
    }
}